export const getSettings = () => (_, getState) => {
  const settings = getState().settings
  return settings
}

export const setInventoryGroup = (groupBy) => ({
  type: '@settings/SET_INVENTORY_GROUP',
  payload: { groupBy }
})

export const setOriginContactFields = (originContactFields) => ({
  type: '@settings/SET_ORIGIN_CONTACT_FIELDS',
  payload: { originContactFields }
})

export const setKitCreatorTour = (showTour) => ({
  type: '@settings/SET_KIT_CREATOR_TOUR',
  payload: { showTour }
})
